/**
 * http 枚举
 */
export enum EnumHttp {
  NEED_LOGIN = 4010,
  TOKEN_EXPIRE = 50,
  WHMCS_MSG = 2222,
}
